export default "__VITE_ASSET__fb4ece47__"